var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconChat = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.019 1.83301C5.69315 1.83301 1.83398 6.17801 1.83398 10.9997C1.83398 12.5397 2.28315 14.1255 3.07148 15.5738C3.21815 15.8122 3.23648 16.1147 3.13565 16.3988L2.52148 18.4522C2.38398 18.9472 2.80565 19.3138 3.27315 19.1672L5.12482 18.6172C5.62898 18.4522 6.02315 18.663 6.49157 18.9472C7.8299 19.7355 9.49732 20.1388 11.0007 20.1388C15.5473 20.1388 20.1673 16.628 20.1673 10.9722C20.1673 6.09551 16.2257 1.83301 11.019 1.83301Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9835 12.1827C10.3327 12.1736 9.81019 11.6511 9.81019 11.0002C9.81019 10.3586 10.3419 9.82689 10.9835 9.83605C11.6344 9.83605 12.1569 10.3586 12.1569 11.0094C12.1569 11.6511 11.6344 12.1827 10.9835 12.1827ZM6.75732 12.1827C6.11565 12.1827 5.58398 11.6511 5.58398 11.0094C5.58398 10.3586 6.10648 9.83606 6.75732 9.83606C7.40815 9.83606 7.93065 10.3586 7.93065 11.0094C7.93065 11.6511 7.40815 12.1736 6.75732 12.1827ZM14.0358 11.0094C14.0358 11.6511 14.5583 12.1827 15.2092 12.1827C15.86 12.1827 16.3825 11.6511 16.3825 11.0094C16.3825 10.3586 15.86 9.83606 15.2092 9.83606C14.5583 9.83606 14.0358 10.3586 14.0358 11.0094Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconChat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-chat.644b24a1.svg";
export { ForwardRef as ReactComponent };